// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2312": "51bf1d169419","3616": "2bd20f1d2224","6495": "a9b28c737317","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}